import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ReactComponent as Logo } from "../../../assets/images/cirrus_logo.svg";
import { ReactComponent as ZkTecoLogo } from "../../../assets/images/zktk_new_logo.svg";
import { REACT_EMPLOYEE_LOGIN_SCREEN, REACT_TERMINAL_PAGE } from "../../../constants/ReactEndPoints";
import CommonUtil from "../../../util/CommonUtils";
import { useLocalizedDate } from "../../../util/customHooks/useLocalizedClock";

export default function Header() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const { formatted: formattedTime } = useLocalizedDate(currentTime, "hh:mm:ss");
  const { formatted: amPm } = useLocalizedDate(currentTime, "a");
  const { formatted: formattedDate } = useLocalizedDate(currentTime, "EEEE, MMMM d, yyyy");

  const terminalName = localStorage.getItem("terminal");
  const deviceTemplate = localStorage.getItem("virtualDeviceId");
  const locationName = localStorage.getItem("location");

  const isTerminalOrLoginPage =
    window.location.href.includes(REACT_EMPLOYEE_LOGIN_SCREEN) ||
    window.location.href.includes(REACT_TERMINAL_PAGE);

  return (
    <Box>
      <Box
        pl={"25px"}
        pr={"25px"}
        display={"flex"}
        backgroundColor={"#023A59"}
        sx={{
          minHeight: "130px",
          position: "relative",
          justifyContent: "space-between",
          alignItems: "center",
          "@media (max-width: 1800px)": {
            minHeight: isTerminalOrLoginPage ? "62px" : "80px",
          },
        }}
      >
        {/* LEFT LOGO */}
        <Box
          display="flex"
          maxWidth={"200px"}
          justifyContent="space-around"
          alignItems="center"
          sx={{
            "@media (max-width: 1800px)": { maxWidth: "120px" },
            "@media (max-width: 1100px)": { maxWidth: "100px" },
          }}
        >
          <Logo />
        </Box>

        {/* CENTER LOGO */}
        <Box
          display="flex"
          justifyContent="space-around"
          alignItems="center"
          maxWidth={"200px"}
          sx={{
            position: { sm: "absolute", md: "absolute", lg: "absolute", xl: "absolute" },
            left: { sm: "44%", md: "44%", lg: "44.5%", xl: "46%" },
            "@media (max-width: 1800px)": { maxWidth: "140px" },
            "@media (max-width: 1100px)": { maxWidth: "130px" },
          }}
        >
          <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" width="100%">
            <ZkTecoLogo />

            {!isTerminalOrLoginPage && (
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                  paddingTop: "5px",
                }}
              >
                {!CommonUtil.isEmptyString(deviceTemplate)
                  ? deviceTemplate
                  : !CommonUtil.isEmptyString(locationName)
                  ? locationName
                  : terminalName}
              </Typography>
            )}
          </Box>
        </Box>

        {/* RIGHT DATE / TIME */}
        <Box>
          <Typography variant="h5" gutterBottom sx={{ display: "flex", justifyContent: "end", color: "#fff" }}>
            <Box>
              <Box
                sx={{
                  fontSize: "52px",
                  fontWeight: "400",
                  "@media (max-width: 1800px)": { fontSize: "28px" },
                }}
              >
                {formattedTime} <span style={{ fontSize: "24px" }}>{amPm}</span>
              </Box>

              <Box
                sx={{
                  fontSize: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                  fontWeight: "400",
                  "@media (max-width: 1800px)": { fontSize: "14px" },
                }}
              >
                {formattedDate}
              </Box>
            </Box>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
